import moment from 'moment-timezone';
import { ensureDate, momentTz } from './date';

type TimeLeft = { minutes: number; seconds: number };

export function getTimeLeft(now: number, date: Date | string): null | TimeLeft {
  const then = new Date(date).getTime();
  if (then < now) {
    return null;
  }
  const secondsLeft = Math.floor((then - now) / 1000);
  const seconds = secondsLeft % 60;
  const minutes = Math.floor(secondsLeft / 60) % 60;

  return { minutes, seconds };
}

export const formatDate = (date: any, format: string) => {
  return moment(date, [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss Z']).format(format);
};

export function parseDate(date: any): moment.Moment | null {
  if (!date) return null;
  try {
    const d = typeof date === 'string' ? ensureDate(date) : new Date(date);
    if (!d || isNaN(d.getTime())) return null;
    const m = momentTz(d);
    if (m && m.isValid()) return m;
    const fallback = moment(d);
    if (fallback && fallback.isValid()) return fallback;
  } catch (e) {
    // Ignore invalid dates
  }
  return null;
}

export function hasTime(dateStr: any, m?: moment.Moment | null): boolean {
  if (typeof dateStr === 'string' && (dateStr.includes('T') || dateStr.includes(':'))) {
    return true;
  }
  if (m && m.isValid() && (m.hours() !== 0 || m.minutes() !== 0)) {
    return true;
  }
  return false;
}

export function formatDateRange(startDate: any, endDate?: any): string | null {
  if (!startDate) return null;

  const start = parseDate(startDate);
  if (!start) {
    return endDate ? `${startDate} - ${endDate}` : String(startDate);
  }

  const end = parseDate(endDate);
  const startHasTime = hasTime(startDate, start);
  const endHasTime = end && hasTime(endDate, end);

  if (end && end.isValid()) {
    const isSameDay = start.isSame(end, 'day');

    if (isSameDay) {
      const dateStr = start.format('LL');
      if (startHasTime && endHasTime) {
        return `${dateStr}, ${start.format('LT')} - ${end.format('LT')}`;
      }
      if (startHasTime) {
        return `${dateStr}, ${start.format('LT')}`;
      }
      return dateStr;
    }

    const startStr = startHasTime ? `${start.format('LL')}, ${start.format('LT')}` : start.format('LL');
    const endStr = endHasTime ? `${end.format('LL')}, ${end.format('LT')}` : end.format('LL');
    return `${startStr} - ${endStr}`;
  }

  const dateStr = start.format('LL');
  if (startHasTime) {
    return `${dateStr}, ${start.format('LT')}`;
  }
  return dateStr;
}

// Alias for backwards compatibility
export const formatOptionDate = formatDateRange;
